import React from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';
import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

interface IProps {
    scrollRef: React.RefObject<HTMLDivElement>,
    tariffLine: Record<string, any>,
}

const TariffLineHeader = ({ scrollRef, tariffLine }: IProps): JSX.Element => {
    const handleCLick = () => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.tariffLines,
            action: 'click details line',
            label: '',
        });
        scrollRef?.current?.scrollIntoView();
    };

    return (
        <ST.Wrapper webpUrl={tariffLine.image_background_webp}>
            {tariffLine.advertising && (
                <NonStaticContainer
                    $desktop={{
                        $top: 24,
                        $right: 24,
                    }}
                    $mobile={{
                        $top: 16,
                        $right: 16,
                    }}
                >
                    <AdvertisingLabelWithTooltip
                        companyName={tariffLine.advertising.companyName}
                        erid={tariffLine.advertising.erid}
                        tooltip={{
                            position: 'bottom-right',
                        }}
                    />
                </NonStaticContainer>
            )}
            <ST.Container>
                <ST.Col>
                    <ST.Header dangerouslySetInnerHTML={{ __html: tariffLine.title_header }}/>
                    <ST.Text dangerouslySetInnerHTML={{ __html: tariffLine.body_for_line_page }}/>
                    <ST.Button type={tariffLine.button_css_type || btnTypes.PRIMARY} onClick={handleCLick}>
                        {tariffLine.button_text || 'Что входит?'}
                    </ST.Button>
                </ST.Col>
                {tariffLine.image_promo &&
                    <ST.ImageCol>
                        <ST.Image>
                            <WebpImage urlWebp={tariffLine.image_promo_webp}>
                                <ST.ImageBlock src={tariffLine.image_promo}/>
                            </WebpImage>
                        </ST.Image>
                    </ST.ImageCol>
                }
            </ST.Container>
        </ST.Wrapper>
    );
};

export default TariffLineHeader;
